import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import AdminMenu from "../../AdminMenu";
import {getFranchiseStoreMappedList } from "../../../services/FranchiseModal/Franchise";
import { formatDate } from "../../../constants/FormateDate";

const FranchiseStoreMappedList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};

  const [franchiseListInfoData, setFranchiseListInfoData] = useState([]);
  const [franchiseStoreListInfoData, setFranchiseStoreListInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchFranchise = () => {
    setLoading(true);
    getFranchiseStoreMappedList(brandId, item.id)
      .then((response) => {
        if (!response.data.error) {
          const ResList = response.data.list;
          const ResStoreList = response.data.storeList;
          setFranchiseListInfoData(ResList);
          setFranchiseStoreListInfoData(ResStoreList);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchFranchise();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((franchiseItem, index) => {

      const storeMap = franchiseStoreListInfoData.filter(
        (storeItem) => storeItem.id === franchiseItem.storeId
      );

      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Franchise Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem.brandFranchise.name}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Franchise Mapped Store :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {storeMap[0].storeName}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Revenue Calculate On :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {franchiseItem?.revenueCalculateOn
                      ? formatDate(franchiseItem?.revenueCalculateOn)
                      : "N/A"}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {franchiseItem.status ? "ACTIVE" : "INACTIVE"}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/Franchise-Store-Map", {
                        state: {
                          item: franchiseItem,
                          franchise: item,
                          storeMap: storeMap[0].storeName,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/franchise-config-list", {
                      state: {
                        franchiseItem: item,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Franchise Store Mapped List
              </p>
            </div>
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() =>
                navigate("/Franchise-Store-Map", {
                  state: {
                    item: null,
                    franchise: item,
                    storeMap: null,
                  }
                })
              }
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : franchiseListInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(franchiseListInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Franchise List Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />

      {/* <UserCreateModal
          setUserCreateModalVisible={setUserCreateModalVisible}
          userCreateModalVisible={userCreateModalVisible}
          sendDataToUserList={receiveDataFromUserCreateModal}
          brandId={brandId}
          selectedUserItemValue={selectedUserItemValue}
          isWareHouseModel={isWareHouseModel}
        />
        <RoleFilterModal
          setRoleFilterModalVisible={setRoleFilterModalVisible}
          roleFilterModalVisible={roleFilterModalVisible}
          sendDataToRoleFromFilter={receiveDataFromRoleFilterModal}
          brandId={brandId}
          isWareHouseModel={isWareHouseModel}
        /> */}
    </div>
  );
};

export default FranchiseStoreMappedList;
